import React from 'react';
import { tag } from '../../../model/tag';
import { List } from '@material-ui/core';
import TagItem from './TagItem';
import { post } from '../../../model/post';

interface IProps {
    handleClickOnTag: (tag: tag) => void;
    tags: tag[];
    post: post;
}


export class TagSelector extends React.Component<IProps>
{
    render() {
        return (
            <List>
                {this.props.tags && this.props.tags.map(t =>
                    <TagItem
                        tag={t}
                        key={t.code}
                        handleClickOnTag={this.props.handleClickOnTag}
                        selected={this.props.post.tags?.findIndex(x => x.code === t.code) > -1}
                    />
                )}
            </List>
        )
    }
}
